var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBritainFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48056 4.69299C1.53795 5.91938 0.827189 7.3329 0.41333 8.86848H6.65605L2.48056 4.69299Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5869 8.86864C23.173 7.33311 22.4622 5.9196 21.5196 4.69321L17.3442 8.86864H23.5869Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.41333 15.1302C0.827237 16.6657 1.538 18.0793 2.48057 19.3056L6.65591 15.1302H0.41333Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3053 2.47979C18.0789 1.53718 16.6655 0.826413 15.1299 0.412506V6.65518L19.3053 2.47979Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69385 21.5177C5.92024 22.4603 7.33376 23.1711 8.86929 23.585V17.3424L4.69385 21.5177Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86924 0.412506C7.33371 0.826412 5.92019 1.53718 4.69385 2.47974L8.86924 6.65513V0.412506Z",
    fill: "#0052B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1299 23.585C16.6654 23.1711 18.0789 22.4603 19.3053 21.5178L15.1299 17.3424V23.585Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3442 15.1302L21.5196 19.3056C22.4622 18.0793 23.173 16.6657 23.5869 15.1302H17.3442Z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 15.1312L20.4852 20.4861C20.7315 20.2399 20.9664 19.9825 21.1906 19.7157L16.6061 15.1312H15.1304V15.1312Z",
    fill: "#D80027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86951 15.1312H8.86941L3.51465 20.486C3.76084 20.7322 4.01823 20.9672 4.28504 21.1913L8.86951 16.6068V15.1312Z",
    fill: "#D80027"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86927 8.86911V8.86902L3.51446 3.51416C3.26818 3.76035 3.03324 4.01774 2.80908 4.28455L7.3936 8.86907H8.86927V8.86911Z",
    fill: "#D80027"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 8.8702L20.4852 3.5153C20.239 3.26901 19.9817 3.03408 19.7148 2.80997L15.1304 7.39448V8.8702Z",
    fill: "#D80027"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritainFlag);
export default __webpack_public_path__ + "static/media/BritainFlag.5bc8319de969543bec9e20603358f03a.svg";
export { ForwardRef as ReactComponent };